<template>
  <div class="w-100">
    <div class="text-center py-5 my-5" v-if="getLoadingPage">
      <loader />
      <p class="body-2-4">Please wait...</p>
    </div>
    <template v-else>
      <RoomCart v-if="cartPageType === 'ROOM'" />
      <AdditionalCart v-else />
    </template>
  </div>
</template>

<script>
  import RoomCart from './BeCart.vue';
  import AdditionalCart from './BeCartAdditional.vue';
  import { mapGetters } from 'vuex';
  
  export default {
    components:{
      RoomCart,
      AdditionalCart
    },
    computed: {
      ...mapGetters(['getBeRoomSubTotal', 'getLoadingPage']),
      cartPageType(){
        return this.getBeRoomSubTotal > 0 ? 'ROOM' : 'ADDITIONAL';
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/hotel/be/BeCartBase.vue